export default __webpack_public_path__ + "static/banner-3fecb188e7c8709f452a3f776c52400e.png";